import __request__ from "routing/request";
export function getContentStreamUserSettings(username, requestOptions) {
  return __request__("GET", `/contentstream/settings/${username}`, null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function setContentStreamUserSettings(JSONbody, username, requestOptions) {
  return __request__("PUT", `/contentstream/settings/${username}`, JSONbody, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
export function getContentStreamTags(requestOptions) {
  return __request__("GET", "/contentstream/tags", null, {}, {
    "Accept": ["application/json"]
  }, requestOptions);
}
